
import React, { Component } from 'react';
import Button from '@material-ui/core/Button';
import FaPencil from '@material-ui/icons/Create';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import TextField from '@material-ui/core/TextField';
import DoneAll from '@material-ui/icons/DoneAll';
import { Text } from '../extensions/LangaugeContainer';
import { Checkbox } from '@material-ui/core';

//Custom CSS
import stylesStepTwo from "../css/StepTwo.module.css"

//import default from '@material-ui/core/BottomNavigationAction/BottomNavigationAction';
const styles = {
    mainwrap: {
        margin: '10px',
        textAlign: 'left'
    },
    commentsection: {
        border: '1px solid #eeeeee',
        boxShadow: '0.5px 1px 0.5px 0.5px rgba(0.2, 0.2, 0.2, 0.2)',
        marginTop: "10px",
        // boxShadow: '0.5px 1px 0.5px 0.5px rgba(0.2,0.2,0.2,0.2)',
    },
    nameholder: {
        position: 'relative',
        fontsize: '16px',
        color: '#ffffff',
        backgroundColor: "#00B0DE",
        padding: '14px 5px 10px 10px',
        height: '48px',
    },
    button: {
        //   height: '35px',
        //padding:'5px',
        backgroundColor: '#ffffff',
        marginLeft: '10px'
    },
    buttonholder: {
        position: 'absolute',
        right: '7px',
        top: '8px',
        color: '#666666',
    },
    item: {
        fontSize: '16px',
        color: '#00B0DE',
        padding: '10px',
        borderBottom: '1px solid #eeeeee',
    },
    kommentar: {
        padding: '10px',
        maxHeight: '40vh',
        overlowY: 'auto',
        overflowX: 'hidden',
        height: '40vh',
        color: '#666666',
    },
    signed: {
        marginRight: '10px',
        color: '#FFFFFF'
    }

    // kommentarfocus: {
    //     outline: 'none',
    //     border: 'thin solid #999999',
    //     boxShadow: 'inset 0px 0px 5px 0px rgba(153, 153, 153, 1)',
    //     boxShadow: 'inset 0px 0px 5px 0px rgba(153, 153, 153, 1)',
    //     boShadow: 'inset 0px 0px 5px 0px rgba(153, 153, 153, 1)'
    // }
}

export default class StepTwo extends Component {
    state = {
        komentar: ""
    }

    saveData = async (a, b, c) => {
        // console.log(a);
        // console.log(b);
        // console.log(c);
        await this.props.SaveData(a, { [b]: c })
        await this.props.SetPropertyValue(a, b, c);

    }

    saveFertigCheckbox =  async(a,b,c) =>{
        console.log(a,b,c);
        if(c===true)
        {
            await this.props.SaveData(a, {[b]: 3});
            await this.props.SetPropertyValue(a, b, 3);
        }
        else{
            await this.props.SaveData(a, {[b]: 4});
            await this.props.SetPropertyValue(a, b, 4);
        }
    }

    checkAuftragStatus = (a) => {
        let selected = 3;
        if (a.length > 0) {
            selected = a.filter(e => e.Selected === 0).length > 0 ? 4 : 3;
        }
        this.props.SetPropertyValue(this.props.app, "Geliefert", selected);
        // switch (a) {
        //     case 3:
        //         return "3";
        //     case 4:
        //         return "4";
        //     case 1:
        //         return "3"
        //     case 2:
        //         return "4"
        //     default:
        //         return "3"
        // }
    }

    setLocalState = (val, e) => {
        this.setState({ komentar: e })
    }

    render() {
        // console.log("StepTwo Props, ", this.props);
        // let app = this.props.app;
        //  console.log(this.props.app.Geliefert);
        //let selected = this.props.app.Geliefert ? this.props.app.Geliefert : "" ;
        //let selected = this.props.app.Positions || [];
        let dokument = this.props.app.Signed || false;
        let { Punkt1, Punkt2, Punkt3 } = this.props.app;
        Punkt1 = !Punkt1 ? "0" : "1";
        Punkt2 = !Punkt2 ? "0" : "1";
        Punkt3 = !Punkt3 ? "0" : "1";

        return (
            <div style={styles.mainwrap}>
                <div style={styles.nameholder}>
                    <span style={styles.span}><Text tid="signDocument" /></span>

                    <div style={styles.buttonholder}>
                        {dokument && <span style={styles.signed}><Text tid="signedDocument" /></span>}
                        <Button size='small'
                            style={styles.button}
                            variant="contained"
                            onClick={this.props.SignAuftrag}
                            disabled={this.props.disabled}
                        >
                            <FaPencil />
                        </Button>
                        <Button size='small'
                            style={styles.button}
                            variant="contained"
                            onClick={this.props.SignAuftragMultiple} // Sign all auftrags for today with specific company.
                            disabled={this.props.disabled}
                        >
                            <DoneAll /><FaPencil />
                        </Button>
                    </div>
                </div>
                <div>
                    <div style={{ textAlign: "left", marginLeft: "10px", position: 'relative' }}>
                        <FormControl component="fieldset">
                            {/* <RadioGroup style={{ display: 'inline' }}
                                value={this.props.app.Geliefert === 4 ? "4" : "3"}
                                onChange={(e) => this.saveData(this.props.app, e.target.name, parseInt(e.target.value))}
                                name="Geliefert"
                            >
                                <FormControlLabel name='4' value='4' control={<Radio color='primary' disabled={(this.props.app.Geliefert === 1)} />} label={<Text tid="partially" />} />
                                <FormControlLabel name='3' value='3' control={<Radio color='primary' disabled={(this.props.app.Geliefert === 1)} />} label={<Text tid="finished" />} />
                            </RadioGroup>  */}
                            {/* Additional punkts */}
                            <table style={{width: '100%'}}>
                                <tbody>
                                    <tr>
                                        <td>
                                            <Text tid="punkt1" />
                                        </td>
                                        <td style={{textAlign: 'right'}}>
                                            <RadioGroup style={{ display: 'inline' }}
                                                value={Punkt1}
                                                onChange={(e) => this.saveData(this.props.app, e.target.name, parseInt(e.target.value))}
                                                name="Punkt1"
                                            >
                                                {/* <Text tid="punkt1" />                            */}
                                                <FormControlLabel value="1" control={<Radio color='primary' />} label={<Text tid="yes" />} />
                                                <FormControlLabel value="0" control={<Radio color='primary' />} label={<Text tid="no" />} />
                                            </RadioGroup>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                            <table style={{width: '100%'}}>
                                <tbody>
                                    <tr>
                                        <td><Text tid="punkt2" /> </td>
                                        <td style={{textAlign: 'right'}}>
                                            <RadioGroup style={{ display: 'inline' }}
                                                value={Punkt2}
                                                onChange={(e) => this.saveData(this.props.app, e.target.name, parseInt(e.target.value))}
                                                name="Punkt2"
                                            >
                                                {/* <Text tid="punkt2" />                       */}
                                                <FormControlLabel style={{ textAlign: 'right' }} value="1" control={<Radio color='primary' />} label={<Text tid="yes" />} />
                                                <FormControlLabel style={{ textAlign: 'right' }} value="0" control={<Radio color='primary' />} label={<Text tid="no" />} />
                                            </RadioGroup>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                            <table style={{width: '100%'}}>
                                <tbody>
                                    <tr>
                                        <td>
                                            <Text tid="punkt3" />
                                        </td>
                                        <td style={{textAlign: 'right'}}>
                                            <RadioGroup style={{ display: 'inline' }}
                                                value={Punkt3}
                                                onChange={(e) => this.saveData(this.props.app, e.target.name, parseInt(e.target.value))}
                                                name="Punkt3"
                                            >
                                                <FormControlLabel value="1" control={<Radio color='primary' />} label={<Text tid="yes" />} />
                                                <FormControlLabel value="0" control={<Radio color='primary' />} label={<Text tid="no" />} />
                                            </RadioGroup>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </FormControl>
                    </div>
                </div>
                <div style={styles.commentsection}>
                        <div style={styles.item}>
                            <Text tid="driverNotes" />
                        </div>
                        <div id='komentar' style={styles.kommentar}>
                            <TextField
                                multiline
                                fullWidth
                                label={<Text tid="comment" />}
                                name="GeliefertDescription"
                                value={this.state.komentar}
                                onBlur={(e) => this.props.SaveData(this.props.app, { GeliefertDescription: e.target.value })}
                                //onChange={(e) => this.props.SetPropertyValue(this.props.app, e.target.name, e.target.value)}
                                onChange={(e) => this.setLocalState(e.target.name, e.target.value)}
                                margin="normal"
                                style={{ marginTop: "0px" }}
                                variant="outlined"
                                inputProps={{ maxLength: 149 }}
                                required={Punkt2  === "0" ? true : false}
                                disabled={this.props.disabled}
                                className={Punkt2 === "0" && this.state.komentar == "" ? stylesStepTwo.mandatory : ""}
                            />
                        </div>
                    </div>
                    <FormControl>
                        <FormControlLabel 
                                control={<Checkbox color="primary" checked={(this.props.app.Geliefert === 4) ? false : true && (Punkt2 === "0" && this.state.komentar == "") ? false : true } name="Geliefert" onChange={(e) => this.saveFertigCheckbox(this.props.app, e.target.name, e.target.checked )}/>} 
                                label="Fertig" />
                    </FormControl> 
            </div>
        );
    }
}